module.exports = __webpack_public_path__ + "img/icn-transmettre.df2e4242.svg";